import { useCallback, useMemo } from "react";

import { Blueprint } from "types/generated";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import TableCellLink from "ds/components/Table/Row/CellLink";

import useBlueprintsAnalytics from "../../hooks/useBlueprintsAnalytics";
import useCellCopyAction from "../useCellCopyAction";
import { BLUEPRINTS_COLUMN_ID } from "../constants";

const BlueprintsTableNameCell = ({
  item: blueprint,
  ...cellProps
}: TableSimpleCellProps<Blueprint>) => {
  const trackAnalytics = useBlueprintsAnalytics();

  const copyAction = useCellCopyAction({
    column: BLUEPRINTS_COLUMN_ID.NAME,
    text: blueprint.name,
  });

  const handlePress = useCallback(() => {
    trackAnalytics("Link clicked");
  }, [trackAnalytics]);

  const actions = useMemo(() => [copyAction], [copyAction]);

  return (
    <TableSimpleCell {...cellProps} role="rowheader" actions={actions}>
      <TableCellLink href={`/blueprint/${blueprint.id}`} onPress={handlePress}>
        {blueprint.name}
      </TableCellLink>
    </TableSimpleCell>
  );
};

export default BlueprintsTableNameCell;
